export default __webpack_public_path__ + "static/media/img4.6caf6d79.png";